import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdminSettingFormContainer from './AdminSettingFormContainer';
import AdminSideSlides from '../../AdminLayout/AdminSideSlides';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import KioskIdelScreen from '../../KioskLayout/KioskIdelScreen';

const messages = defineMessages({
  Settings: {
    id: 'Admin.Settings.Settings',
    defineMessages: 'Settings'
  }
});

export class AdminSettingLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle: this.props && this.props.intl.formatMessage(messages.Settings),
    height: 300
  };

  render() {
    return (
      <>
        <AdminSideSlides
          pageTitle={this.state.pageTitle}
          customTop={this.state.customTop}
          customHeight={120}
        />
        <AdminSettingFormContainer />
        <KioskIdelScreen />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  const kiosk = state.get('kiosk');
  return { ...kiosk };
};
export default connect(mapStateToProps)(injectIntl(AdminSettingLayout));
